import React from 'react';
import * as S from '../ExternalDataTabs.styles';

interface HudleUserTabProps {
  data: Record<string, any>;
}

export const HudleUserTab: React.FC<HudleUserTabProps> = ({ data }) => {
  const user = data.user || {};

  const formatDate = (dateString?: string) => {
    if (!dateString) return '—';
    try {
      return new Date(dateString).toLocaleString('ru-RU');
    } catch {
      return dateString;
    }
  };

  return (
    <div>
      <S.SectionTitle>Основная информация</S.SectionTitle>
      <S.InfoRow>
        <S.InfoLabel>ID</S.InfoLabel>
        <S.InfoValue>{user.id || '—'}</S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>UID</S.InfoLabel>
        <S.InfoValue>{user.uid || '—'}</S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Имя пользователя</S.InfoLabel>
        <S.InfoValue>{user.username || '—'}</S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Отображаемое имя</S.InfoLabel>
        <S.InfoValue>{user.display_name || '—'}</S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Email</S.InfoLabel>
        <S.InfoValue>{user.email || '—'}</S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Телефон</S.InfoLabel>
        <S.InfoValue>{user.phone || '—'}</S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Биография</S.InfoLabel>
        <S.InfoValue>{user.bio || '—'}</S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Статус</S.InfoLabel>
        <S.InfoValue>
          {user.status ? (
            <S.Badge $variant={user.status === 'online' ? 'success' : 'info'}>
              {user.status}
            </S.Badge>
          ) : '—'}
        </S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Сотрудник</S.InfoLabel>
        <S.InfoValue>
          {user.is_staff !== undefined ? (
            <S.Badge $variant={user.is_staff ? 'info' : undefined}>
              {user.is_staff ? 'Да' : 'Нет'}
            </S.Badge>
          ) : '—'}
        </S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Администратор</S.InfoLabel>
        <S.InfoValue>
          {user.is_admin !== undefined ? (
            <S.Badge $variant={user.is_admin ? 'warning' : undefined}>
              {user.is_admin ? 'Да' : 'Нет'}
            </S.Badge>
          ) : '—'}
        </S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Забанен</S.InfoLabel>
        <S.InfoValue>
          {user.is_banned !== undefined ? (
            <S.Badge $variant={user.is_banned ? 'error' : 'success'}>
              {user.is_banned ? 'Да' : 'Нет'}
            </S.Badge>
          ) : '—'}
        </S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Email подтвержден</S.InfoLabel>
        <S.InfoValue>
          {user.is_email_verified !== undefined ? (
            <S.Badge $variant={user.is_email_verified ? 'success' : 'error'}>
              {user.is_email_verified ? 'Да' : 'Нет'}
            </S.Badge>
          ) : '—'}
        </S.InfoValue>
      </S.InfoRow>
      {user.ban_info && (
        <>
          <S.SectionTitle>Информация о бане</S.SectionTitle>
          <S.InfoRow>
            <S.InfoLabel>Забанен</S.InfoLabel>
            <S.InfoValue>{formatDate(user.ban_info.banned_at)}</S.InfoValue>
          </S.InfoRow>
          <S.InfoRow>
            <S.InfoLabel>Забанен пользователем ID</S.InfoLabel>
            <S.InfoValue>{user.ban_info.banned_by || '—'}</S.InfoValue>
          </S.InfoRow>
          <S.InfoRow>
            <S.InfoLabel>Причина</S.InfoLabel>
            <S.InfoValue>{user.ban_info.ban_reason || '—'}</S.InfoValue>
          </S.InfoRow>
        </>
      )}
      <S.SectionTitle>Даты</S.SectionTitle>
      <S.InfoRow>
        <S.InfoLabel>Создан</S.InfoLabel>
        <S.InfoValue>{formatDate(user.created_at)}</S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Обновлен</S.InfoLabel>
        <S.InfoValue>{formatDate(user.updated_at)}</S.InfoValue>
      </S.InfoRow>
    </div>
  );
};

